import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ForcelogoutExistingsessionService } from './forcelogout-existingsession.service';

@Component({
  selector: 'app-forcelogout-existingsession',
  templateUrl: './forcelogout-existingsession.component.html',
  styleUrls: ['./forcelogout-existingsession.component.scss']
})
export class ForcelogoutExistingsessionComponent implements OnInit {
    public modalOpen: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private _forcelogoutExistingsessionService: ForcelogoutExistingsessionService,

  ) { }

  ngOnInit() {
    this._forcelogoutExistingsessionService.modal.subscribe(isOpen => {
        console.log("i received to open modal ?", isOpen);
        this.modalOpen = isOpen as boolean;
    });

  }
  closeModal() {
    this._forcelogoutExistingsessionService.close();
    this.activeModal.dismiss();
}

}



// WEBPACK FOOTER //
// ./src/app/forcelogout-existingsession/forcelogout-existingsession.component.ts